// import React, { useState } from 'react';
// import {
//     Box,
//     Typography,
//     Paper,
//     Stack,
//     TextField,
//     Button,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     TablePagination,
//     Chip,
//     Skeleton,
//     Avatar,
//     Select,
//     MenuItem,
//     InputLabel,
//     FormControl
// } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import { useAdminAllVendors } from 'hooks/useVendors';

// const statusOptions = ['All', 'pending', 'approved', 'suspended', 'rejected'];

// export default function VendorList() {
//     const navigate = useNavigate();

//     // 🔹 Table State
//     const [page, setPage] = useState(0);
//     const [rowsPerPage, setRowsPerPage] = useState(10);
//     const [search, setSearch] = useState('');
//     const [statusFilter, setStatusFilter] = useState('All');

//     // 🔹 Data Fetching
//     const {
//         data: vendorData,
//         isLoading,
//         isError
//     } = useAdminAllVendors({
//         page: page + 1,
//         limit: rowsPerPage,
//         search: search || undefined,
//         status: statusFilter !== 'All' ? statusFilter : undefined
//     });

//     const vendors = vendorData?.data || [];
//     const totalVendors = vendorData?.total || 0;

//     // 🔹 UI Helpers
//     const getStatusColor = (status) => {
//         switch (status) {
//             case 'approved':
//                 return 'success';
//             case 'pending':
//                 return 'warning';
//             case 'suspended':
//                 return 'error';
//             case 'rejected':
//                 return 'default';
//             default:
//                 return 'primary';
//         }
//     };

//     const handleChangePage = (event, newPage) => {
//         setPage(newPage);
//     };

//     const handleChangeRowsPerPage = (event) => {
//         setRowsPerPage(parseInt(event.target.value, 10));
//         setPage(0);
//     };

//     return (
//         <Box p={3} sx={{ background: '#f5f6fa', minHeight: '100vh' }}>
//             <Stack direction="row" justifyContent="space-between" alignItems="center" mb={4}>
//                 <Typography variant="h4" fontWeight={700}>
//                     Vendor Management
//                 </Typography>
//                 <Button variant="contained" color="primary" onClick={() => navigate('/admin/vendors/new')} sx={{ px: 3, fontWeight: 600 }}>
//                     + Register New Vendor
//                 </Button>
//             </Stack>

//             <Paper sx={{ width: '100%', borderRadius: 3, overflow: 'hidden', p: 2 }}>
//                 {/* 🔍 Filters Section */}
//                 <Stack direction="row" spacing={2} mb={3} alignItems="center">
//                     <TextField
//                         label="Search Store or Owner"
//                         variant="outlined"
//                         size="small"
//                         sx={{ width: 350 }}
//                         placeholder="Search..."
//                         onChange={(e) => setSearch(e.target.value)}
//                     />

//                     <FormControl size="small" sx={{ minWidth: 160 }}>
//                         <InputLabel>Status Filter</InputLabel>
//                         <Select value={statusFilter} label="Status Filter" onChange={(e) => setStatusFilter(e.target.value)}>
//                             {statusOptions.map((opt) => (
//                                 <MenuItem key={opt} value={opt}>
//                                     {opt.charAt(0).toUpperCase() + opt.slice(1)}
//                                 </MenuItem>
//                             ))}
//                         </Select>
//                     </FormControl>
//                 </Stack>

//                 {/* 📊 Table Section */}
//                 <TableContainer>
//                     <Table stickyHeader>
//                         <TableHead>
//                             <TableRow>
//                                 <TableCell sx={{ fontWeight: 700 }}>Store & Owner</TableCell>
//                                 <TableCell sx={{ fontWeight: 700 }}>Contact Info</TableCell>
//                                 <TableCell sx={{ fontWeight: 700 }}>Category</TableCell>
//                                 <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
//                                 <TableCell sx={{ fontWeight: 700 }}>Wallet Balance</TableCell>
//                                 <TableCell align="right" sx={{ fontWeight: 700 }}>
//                                     Actions
//                                 </TableCell>
//                             </TableRow>
//                         </TableHead>
//                         <TableBody>
//                             {isLoading
//                                 ? // Render Skeletons while loading
//                                   [...Array(rowsPerPage)].map((_, index) => (
//                                       <TableRow key={index}>
//                                           <TableCell>
//                                               <Skeleton variant="text" width={150} />
//                                           </TableCell>
//                                           <TableCell>
//                                               <Skeleton variant="text" width={120} />
//                                           </TableCell>
//                                           <TableCell>
//                                               <Skeleton variant="text" width={80} />
//                                           </TableCell>
//                                           <TableCell>
//                                               <Skeleton variant="rectangular" width={70} height={24} sx={{ borderRadius: 1 }} />
//                                           </TableCell>
//                                           <TableCell>
//                                               <Skeleton variant="text" width={60} />
//                                           </TableCell>
//                                           <TableCell align="right">
//                                               <Skeleton variant="circular" width={30} height={30} />
//                                           </TableCell>
//                                       </TableRow>
//                                   ))
//                                 : vendors.map((vendor) => (
//                                       <TableRow key={vendor.id} hover>
//                                           <TableCell>
//                                               <Stack direction="row" spacing={2} alignItems="center">
//                                                   <Avatar src={vendor.logo} variant="rounded" sx={{ width: 40, height: 40 }}>
//                                                       {vendor.name?.[0]}
//                                                   </Avatar>
//                                                   <Box>
//                                                       <Typography variant="subtitle2" fontWeight={600}>
//                                                           {vendor.name}
//                                                       </Typography>
//                                                       {/* <Typography variant="caption" color="text.secondary">
//                                                           Owner: {vendor.user.firstName || 'N/A'}
//                                                       </Typography> */}
//                                                   </Box>
//                                               </Stack>
//                                           </TableCell>
//                                           <TableCell>
//                                               <Typography variant="body2">{vendor.email}</Typography>
//                                               <Typography variant="caption" color="text.secondary">
//                                                   {vendor.phoneNumber}
//                                               </Typography>
//                                           </TableCell>
//                                           <TableCell>
//                                               <Chip label={vendor.category || 'General'} size="small" variant="outlined" />
//                                           </TableCell>
//                                           <TableCell>
//                                               <Chip
//                                                   label={vendor.status?.toUpperCase()}
//                                                   color={getStatusColor(vendor.status)}
//                                                   size="small"
//                                                   sx={{ fontWeight: 600, fontSize: '0.7rem' }}
//                                               />
//                                           </TableCell>
//                                           <TableCell>
//                                               <Typography variant="body2" fontWeight={600}>
//                                                   ₦{vendor.walletBalance?.toLocaleString() || '0'}
//                                               </Typography>
//                                           </TableCell>
//                                           <TableCell align="right">
//                                               <Button
//                                                   variant="outlined"
//                                                   size="small"
//                                                   onClick={() => navigate(`/admin/vendors/${vendor.id}`)}
//                                               >
//                                                   Manage
//                                               </Button>
//                                           </TableCell>
//                                       </TableRow>
//                                   ))}

//                             {!isLoading && vendors.length === 0 && (
//                                 <TableRow>
//                                     <TableCell colSpan={6} align="center" sx={{ py: 3 }}>
//                                         <Typography color="text.secondary">No vendors found matching your criteria.</Typography>
//                                     </TableCell>
//                                 </TableRow>
//                             )}
//                         </TableBody>
//                     </Table>
//                 </TableContainer>

//                 <TablePagination
//                     rowsPerPageOptions={[5, 10, 25]}
//                     component="div"
//                     count={totalVendors}
//                     rowsPerPage={rowsPerPage}
//                     page={page}
//                     onPageChange={handleChangePage}
//                     onRowsPerPageChange={handleChangeRowsPerPage}
//                 />
//             </Paper>
//         </Box>
//     );
// }
import React, { useState } from 'react';
import {
    Box,
    Typography,
    Paper,
    Stack,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Chip,
    Skeleton,
    Avatar,
    MenuItem,
    Grid,
    IconButton,
    InputAdornment,
    Drawer,
    Divider,
    Tooltip,
    Badge
} from '@mui/material';
import { Search as SearchIcon, Storefront, AddBusiness, CheckCircle, DoNotDisturb, Star, Settings, Verified } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAdminAllVendors } from 'hooks/useVendors';
import { useAdminAllMarketCategories } from 'hooks/useMarketCategory';
import FilterDrawer from 'components/common/FilterDrawer';
import PermissionGuard from 'ui-component/PermissionGuard';
import { FilterList } from '@mui/icons-material';

export default function VendorList() {
    const navigate = useNavigate();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [search, setSearch] = useState('');
    const [selectedVendor, setSelectedVendor] = useState(null);

    const [filterOpen, setFilterOpen] = useState(false);
    const [filters, setFilters] = useState({}); // Store active filters

    // Fetch Categories for Filter Dropdown
    const { data: categoryRes } = useAdminAllMarketCategories();
    const categories = categoryRes?.data || [];

    const {
        data: vendorRes,
        isLoading,
        refetch
    } = useAdminAllVendors({
        page: page + 1,
        limit: rowsPerPage,
        search: search || undefined,
        ...filters // Spread filters into API params
    });

    const vendors = vendorRes?.data || [];
    const totalVendors = vendorRes?.total || 0;

    const statusColorMap = {
        active: 'success',
        inactive: 'warning',
        rejected: 'error',
        suspended: 'default'
    };

    const handleFilterApply = (newFilters) => {
        setFilters(newFilters);
        setPage(0);
    };

    const filterConfig = [
        { name: 'marketCategoryId', label: 'Category', type: 'select', options: categories.map((c) => ({ label: c.name, value: c.id })) },
        { name: 'state', label: 'State', type: 'text' },
        { name: 'lga', label: 'LGA', type: 'text' },
        { name: 'ratings', label: 'Min Rating', type: 'number' },
        {
            name: 'isAvailable',
            label: 'Availability',
            type: 'select',
            options: [
                { label: 'Available', value: true },
                { label: 'Unavailable', value: false }
            ]
        },
        {
            name: 'kycStatus',
            label: 'KYC Status',
            type: 'select',
            options: [
                { label: 'Not Submitted', value: 'not_submitted' },
                { label: 'Pending', value: 'pending' },
                { label: 'Verified', value: 'verified' },
                { label: 'Failed', value: 'failed' }
            ]
        },
        {
            name: 'status',
            label: 'Store Status',
            type: 'select',
            options: [
                { label: 'Active', value: 'active' },
                { label: 'Inactive', value: 'inactive' },
                { label: 'Suspended', value: 'suspended' },
                { label: 'Rejected', value: 'rejected' }
            ]
        },
        {
            name: 'sortBy',
            label: 'Sort By',
            type: 'select',
            options: [
                { label: 'Newest', value: 'createdAt' },
                { label: 'Rating', value: 'rating' },
                { label: 'Name', value: 'name' }
            ]
        },
        {
            name: 'sortOrder',
            label: 'Sort Order',
            type: 'select',
            options: [
                { label: 'Descending', value: 'desc' },
                { label: 'Ascending', value: 'asc' }
            ]
        },
        { name: 'startDate', label: 'Start Date', type: 'date' },
        { name: 'endDate', label: 'End Date', type: 'date' }
    ];

    return (
        <Box p={3} sx={{ background: '#f5f6fa', minHeight: '100vh' }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={4}>
                <Typography variant="h4" fontWeight={700}>
                    Vendors & Merchants
                </Typography>
                {/* <Button
                    variant="contained"
                    startIcon={<AddBusiness />}
                    onClick={() => navigate('/admin/vendors/new')}
                    sx={{ borderRadius: 2 }}
                >
                    Add New Vendor
                </Button> */}
            </Stack>

            {/* 1. Vendor KPIs */}
            <Grid container spacing={3} mb={4}>
                <VendorStatCard title="Stores" value={totalVendors} color="#2e7d32" icon={<Storefront color="success" />} />
                <VendorStatCard title="Top Rated" value="12" color="#ed6c02" icon={<Star color="warning" />} />
                {/* <VendorStatCard title="Total Orders" value="1,240" color="#1976d2" icon={<CheckCircle color="primary" />} /> */}
            </Grid>

            <Paper sx={{ width: '100%', borderRadius: 3, p: 2, overflow: 'hidden' }}>
                <Stack direction="row" spacing={2} mb={3}>
                    <TextField
                        placeholder="Search Store Name or Category..."
                        size="small"
                        sx={{ width: 400 }}
                        onChange={(e) => setSearch(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon color="action" fontSize="small" />
                                </InputAdornment>
                            )
                        }}
                    />

                    <Stack direction="row" spacing={1} alignItems="center" sx={{ ml: 2 }}>
                        <Badge badgeContent={Object.keys(filters).length} color="primary">
                            <Button variant="outlined" startIcon={<FilterList />} onClick={() => setFilterOpen(true)}>
                                Filters
                            </Button>
                        </Badge>
                        {Object.keys(filters).length > 0 && (
                            <Button variant="text" onClick={() => setFilters({})} color="error" size="small">
                                Reset
                            </Button>
                        )}
                    </Stack>
                </Stack>

                <TableContainer>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 600 }}>Store Details</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Category</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Store Status</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>KYC Status</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Commission</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Rating</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 600 }}>
                                    Actions
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {isLoading
                                ? [...Array(5)].map((_, i) => (
                                      <TableRow key={i}>
                                          <TableCell colSpan={6}>
                                              <Skeleton height={50} />
                                          </TableCell>
                                      </TableRow>
                                  ))
                                : vendors.map((vendor) => (
                                      <TableRow key={vendor.id} hover>
                                          <TableCell>
                                              <Stack direction="row" spacing={2} alignItems="center">
                                                  <Avatar
                                                      src={vendor.logo}
                                                      variant="rounded"
                                                      sx={{ width: 45, height: 45, bgcolor: '#eee' }}
                                                  >
                                                      <Storefront color="disabled" />
                                                  </Avatar>
                                                  <Box>
                                                      <Typography variant="subtitle2" fontWeight={700}>
                                                          {vendor.name}
                                                      </Typography>
                                                      <Typography variant="caption" color="text.secondary">
                                                          {vendor.address}
                                                      </Typography>
                                                  </Box>
                                              </Stack>
                                          </TableCell>

                                          <TableCell>
                                              <Chip label={vendor.category || 'General'} size="small" variant="outlined" />
                                          </TableCell>

                                          <TableCell>
                                              <Chip
                                                  label={vendor.status}
                                                  size="small"
                                                  color={statusColorMap[vendor.status] ?? 'default'}
                                                  sx={{ fontWeight: 800, fontSize: '0.6rem' }}
                                              />
                                          </TableCell>

                                          <TableCell>
                                              <Chip
                                                  label={vendor.kycStatus?.replace('_', ' ') || 'not submitted'}
                                                  size="small"
                                                  variant="outlined"
                                                  color={
                                                      vendor.kycStatus === 'verified' || vendor.kycStatus === 'approved'
                                                          ? 'success'
                                                          : vendor.kycStatus === 'pending'
                                                          ? 'info'
                                                          : 'error'
                                                  }
                                                  sx={{ fontWeight: 800, fontSize: '0.6rem' }}
                                              />
                                          </TableCell>

                                          <TableCell>
                                              <Typography variant="body2" fontWeight={600}>
                                                  {vendor.commissionRate || 10}%
                                              </Typography>
                                          </TableCell>

                                          <TableCell>
                                              <Stack direction="row" alignItems="center" spacing={0.5}>
                                                  <Star sx={{ fontSize: 16, color: '#ed6c02' }} />
                                                  <Typography variant="body2" fontWeight={700}>
                                                      {vendor.rating || '0.0'}
                                                  </Typography>
                                              </Stack>
                                          </TableCell>

                                          <TableCell align="right">
                                              <IconButton onClick={() => setSelectedVendor(vendor)}>
                                                  <Settings fontSize="small" />
                                              </IconButton>
                                          </TableCell>
                                      </TableRow>
                                  ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <TablePagination
                    component="div"
                    count={totalVendors}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={(_, p) => setPage(p)}
                    onRowsPerPageChange={(e) => setRowsPerPage(parseInt(e.target.value, 10))}
                />
            </Paper>

            <VendorQuickDrawer open={!!selectedVendor} vendor={selectedVendor} onClose={() => setSelectedVendor(null)} />

            <FilterDrawer
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                onApply={handleFilterApply}
                initialFilters={filters}
                config={filterConfig}
            />
        </Box>
    );
}

function VendorStatCard({ title, value, icon, color }) {
    return (
        <Grid item xs={12} sm={4}>
            <Paper sx={{ p: 2.5, borderRadius: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box>
                    <Typography variant="caption" color="text.secondary" fontWeight={600}>
                        {title.toUpperCase()}
                    </Typography>
                    <Typography variant="h5" fontWeight={800}>
                        {value}
                    </Typography>
                </Box>
                <Avatar sx={{ bgcolor: `${color}15`, p: 1 }}>{icon}</Avatar>
            </Paper>
        </Grid>
    );
}

// --- Quick Control Drawer ---
function VendorQuickDrawer({ open, vendor, onClose }) {
    const navigate = useNavigate();
    if (!vendor) return null;
    return (
        <Drawer anchor="right" open={open} onClose={onClose}>
            <Box sx={{ width: 380, p: 3 }}>
                <Typography variant="h6" fontWeight={700}>
                    Store Settings
                </Typography>
                <Divider sx={{ my: 2 }} />

                <Stack spacing={3}>
                    <Box sx={{ textAlign: 'center', py: 2 }}>
                        <Avatar src={vendor.logo} variant="rounded" sx={{ width: 100, height: 100, mx: 'auto', mb: 2 }} />
                        <Typography variant="h6" fontWeight={700}>{vendor.name}</Typography>
                        <Chip
                            label={`KYC: ${vendor.kycStatus?.replace('_', ' ').toUpperCase() || 'NOT SUBMITTED'}`}
                            color={
                                vendor.kycStatus === 'verified' || vendor.kycStatus === 'approved'
                                    ? 'success'
                                    : vendor.kycStatus === 'pending'
                                    ? 'info'
                                    : 'error'
                            }
                            size="small"
                            sx={{ mt: 1, fontWeight: 700 }}
                        />
                    </Box>

                    <Box p={2} sx={{ bgcolor: '#f9f9f9', borderRadius: 2 }}>
                        <Typography variant="subtitle2" mb={2}>
                            Operational Toggles
                        </Typography>
                        {/* <Stack spacing={1.5}>
                            <Button
                                fullWidth
                                variant={vendor.isOpen ? 'outlined' : 'contained'}
                                color={vendor.isOpen ? 'error' : 'success'}
                            >
                                {vendor.isOpen ? 'Force Close Store' : 'Open Store Now'}
                            </Button>
                            <Button fullWidth variant="outlined">
                                Edit Business Hours
                            </Button>
                        </Stack> */}
                    </Box>

                    <Box>
                        <Button fullWidth variant="contained" color="primary" onClick={() => navigate(`/admin/vendors/${vendor.id}`)}>
                            View
                        </Button>
                    </Box>
                </Stack>
            </Box>
        </Drawer>
    );
}
